import { useEffect, useState, useContext, useRef } from "react";
import { DataContext } from "../../../context/DataContext";
import { petitions } from "../../../api/calls";
import { toast } from "sonner";
import Select from "react-select";
import { useForm } from "react-hook-form";
import Table from "../../componentsTable/TanStackTable";
import imgLight from "../../../frontend/assets/img/spot-illustrations/38.webp";
import imgDark from "../../../frontend/assets/img/spot-illustrations/dark_38.webp";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import customStyles from "../../../frontend/styles/select";

function NuevoCliente() {
  const { session, idEmpresa } = useContext(DataContext);

  //SELECT
  const [rubroContribuyente, setRubroContribuyente] = useState([]);
  const [tPersona, setTPersona] = useState([]);
  const [tIdentidad, setTIdentidad] = useState([]);
  const [pais, setPais] = useState([]);
  const [distrito, setDistrito] = useState([]);
  const [provincia, setProvincia] = useState([]);
  const [moneda, setMoneda] = useState([]);
  const [region, setRegion] = useState([]);
  const [tpago, setTpago] = useState([]);

  const navigate = useNavigate();

  const [filtering, setFiltering] = useState("");

  const [contacto, setContacto] = useState([]);
  const [correo, setCorreo] = useState([]);

  //MODALS
  const modalRef1 = useRef(null);
  const closeModal1 = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef1.current);
    modalInstance.hide();
  };

  const modalRef2 = useRef(null);
  const closeModal2 = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
    modalInstance.hide();
  };

  //COLUMNS
  const columnsContacto = [
    {
      header: "Nro. Documento",
      accessorKey: "nroDoc",
    },
    {
      header: "Nombre completo",
      accessorKey: "apeNombres",
    },
    {
      header: "Cargo",
      accessorKey: "cargo",
    },
    {
      header: "Telefono",
      accessorKey: "telefono",
    },
    {
      header: "Movil",
      accessorKey: "movil",
    },
    {
      header: "Email",
      accessorKey: "email",
    },
    {
      header: "Lic. Conducir",
      accessorKey: "licConducir",
    },
    {
      header: "Observacion",
      accessorKey: "obs",
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <span className="fas fa-ellipsis-h fs-10"></span>
          </button>
          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item text-danger"
              onClick={() => {
                deleteContacto(row.original.nroDoc);
              }}
            >
              Eliminar
            </button>
          </div>
        </div>
      ),
    },
  ];

  const columnsCorreo = [
    {
      header: "Orden",
      accessorKey: "id",
    },
    {
      header: "Nombre",
      accessorKey: "nombre",
    },
    {
      header: "Correo",
      accessorKey: "correo",
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <span className="fas fa-ellipsis-h fs-10"></span>
          </button>
          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item text-danger"
              onClick={() => {
                deleteCorreo(row.original.id);
              }}
            >
              Eliminar
            </button>
          </div>
        </div>
      ),
    },
  ];

  const tipo = [
    { value: "C", label: "Cliente" },
    { value: "P", label: "Proveedor" },
  ];

  const form1 = useForm({
    defaultValues: {
      nroDoc: "",
      tipo: "C",
      kardex: true,
      razon: "",
      direccion: "",
      obs: "",
      telefono1: "",
      telefono2: "",
      email: "",
    },
  });

  const form2 = useForm();
  const form3 = useForm();

  useEffect(() => {
    const fetchRubro = async () => {
      const response = await petitions.getRubroContribuyente(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));

        setRubroContribuyente(array);

        if (array.length > 0) {
          form1.setValue("idRubro", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchRubro();
  }, [form1, session, idEmpresa]);


  useEffect(() => {
    const fetchTPersona = async () => {
      const response = await petitions.getTPersona(
        idEmpresa(),
        session().token
      );

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));

        setTPersona(array);

        if (array.length > 0) {
          form1.setValue("idTPersona", array[0].value, {
            shouldValidate: true,
          });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPersona();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchTDIdentidad = async () => {
      const response = await petitions.getTDIdentidad(
        idEmpresa(),
        session().token
      );

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));

        setTIdentidad(array);

        if (array.length > 0) {
          form1.setValue("idTDIdentidad", array[0].value, {
            shouldValidate: true,
          });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTDIdentidad();
  }, [form1, session, idEmpresa]);


 useEffect(() => {
    const fetchPais = async () => {
      const response = await petitions.getPais(idEmpresa(), session().token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));

        setPais(array);

        if (array.length > 0) {
          form1.setValue("idPais", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchPais();
  }, [form1, session, idEmpresa]);


  useEffect(() => {
    const fetchDistrito = async () => {
      const response = await petitions.getDistrito(
        idEmpresa(),
        session().token
      );

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));

        setDistrito(array);

        if (array.length > 0) {
          form1.setValue("idDistrito", array[0].value, {
            shouldValidate: true,
          });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchDistrito();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchProvincia = async () => {
      const response = await petitions.getProvincia(
        idEmpresa(),
        session().token
      );

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idProvincia,
          label: e.descripcion,
        }));

        setProvincia(array);

        if (array.length > 0) {
          form1.setValue("idProvincia", array[0].value, {
            shouldValidate: true,
          });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchProvincia();
  }, [form1, session, idEmpresa]);


  useEffect(() => {
    const fetchMoneda = async () => {
      const response = await petitions.getMoneda(idEmpresa(), session().token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMoneda.toString(),
          label: e.simbolo + " - " + e.descripcion,
        }));

        setMoneda(array);

        if (array.length > 0) {
          form1.setValue("idMoneda", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMoneda();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchRegion = async () => {
      const response = await petitions.getRegion(idEmpresa(), session().token);

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));

        setRegion(array);

        if (array.length > 0) {
          form1.setValue("idRegion", array[0].value, { shouldValidate: true });
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchRegion();
  }, [form1, session, idEmpresa]);

  useEffect(() => {
    const fetchTPago = async () => {
      const response = await petitions.getTPago(idEmpresa(), session().token);
      if (response.status === "success") {
        var array = [];
        response.data.forEach((e) => {
          if (e.estado === "S") {
            array.push({ value: e.idTpago, label: e.descripcion });
          }
        });
        setTpago(array);
        array.length > 0 &&
          form1.setValue("tpago", array[0].value, { shouldValidate: true });
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPago();
  }, [form1, idEmpresa, session]);

  const apiSunat = async () => {
    const tipo = form1.getValues("idTPersona");
    const dniruc = form1.getValues("nroDoc");

    if (tipo === undefined || tipo === "0" || dniruc === "") {
      toast.info("Complete los datos por favor, (tipo de persona),(dni/ruc)");
      return;
    }

    if (tipo === "1") {
      const response = await petitions.getDni(dniruc, session().token);
      if (response.data?.success) {
        form1.setValue(
          "razon",
          `${response.data.nombres} ${response.data.apellidoPaterno} ${response.data.apellidoMaterno}`,
          { shouldValidate: true }
        );
        form1.setValue("direccion", "", { shouldValidate: true });
        return;
      } else {
        toast.warning("DNI con el numero " + dniruc + " no encontrado");
        return;
      }
    } else {
      const response = await petitions.getRuc(dniruc, session().token);
      if (response.data?.ruc !== undefined) {
        form1.setValue("razon", `${response.data.razonSocial}`, {
          shouldValidate: true,
        });
        form1.setValue("direccion", `${response.data.direccion}`, {
          shouldValidate: true,
        });
        return;
      } else {
        toast.warning("RUC con el numero " + dniruc + " no encontrado");
        return;
      }
    }
  };

  //CONTACTO
  const addContacto = form2.handleSubmit(async (data) => {
    setContacto([...contacto, data]);
    form2.reset();
    closeModal1();
  });

  const deleteContacto = (nrodoc) => {
    setContacto(contacto.filter((item) => item.nroDoc !== nrodoc));
  };

  const addCorreo = form3.handleSubmit(async (data) => {
    data.id = correo.length > 0 ? correo[correo.length - 1].id + 1 : 0;
    setCorreo([...correo, data]);
    form3.reset();
    closeModal2();
  });

  const deleteCorreo = (id) => {
    setCorreo(correo.filter((item) => item.id !== id));
  };

  //CLIENTE
  const sendCliente = form1.handleSubmit(async (data) => {
    data.kardex = data.kardex ? "S" : "N";
    data.idcont = data.nroDoc;

    contacto.forEach((obj) => {
      obj.idcontrib = data.nroDoc;
    });

    correo.forEach((obj) => {
      obj.idcontrib = data.nroDoc;
    });

    const obj = {
      objCliente: data,
      listContacto: contacto,
      listCorreo: correo,
    };
    const response = await petitions.insertClienteData(
      idEmpresa(),
      session().token,
      obj
    );
    if (response.status === "success") {
      if (Array.isArray(response.data)) {
        toast("¿Deseariá ir al listado de clientes?", {
          action: {
            label: "Ir",
            onClick: () => {
              navigate("/main/VerCliente", { replace: true });
            },
          },
        });
        toast.success("Cliente registrado correctamente");
        limpiar();
      } else {
        toast.error("Ocurrio un problema");
      }
    } else {
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  }, () => {
      // This function is called when validation fails: (error) => {}
      toast.warning("Por favor, complete los campos obligatorios.")
      document.querySelector('[data-wizard-step="1"]').click();
    }
);

  const limpiar = () => {
    form1.reset();
    form2.reset();
    form3.reset();
    setContacto([]);
    setCorreo([]);
    document.querySelector('[data-wizard-step="1"]').click();
  };

  return (
    <>
      <h2 className="mb-2">Registro cliente</h2>
      <h5 className="text-body-tertiary fw-semibold mb-2">
        Completa los datos de tu cliente/proveedor para generar las ventas y
        compras en tu empresa.
      </h5>
      <div className="row mb-9">
        <div className="col-12 col-xxl-6">
          <div
            className="card shadow-none border my-4"
            data-component-card="data-component-card"
          >
            <div className="card-header p-4 border-bottom bg-body">
              <div className="row g-3 justify-content-between align-items-center">
                <div className="col-12 col-md">
                  <h4 className="text-body mb-0" data-anchor="data-anchor">
                    Datos generales
                  </h4>
                </div>
                <div className="col col-md-auto">
                  <nav
                    className="nav justify-content-end doc-tab-nav align-items-center"
                    role="tablist"
                  >
                    <NavLink
                      className="btn btn-link px-2 copy-code-btn"
                      to={"/main/VerCliente"}
                    >
                      Ir a listado de clientes
                    </NavLink>
                    <button
                      className="btn btn-sm btn-phoenix-danger preview-btn ms-2 rounded-4"
                      type="button"
                      onClick={() => {
                        limpiar();
                      }}
                    >
                      <span className="far fa-trash-alt"></span> Limpiar
                    </button>
                  </nav>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="p-4 code-to-copy">
                <div
                  className="card theme-wizard mb-5 rounded-4"
                  data-theme-wizard="data-theme-wizard"
                >
                  <div className="card-header bg-body-highlight pt-3 pb-2 border-bottom-0">
                    <ul className="nav justify-content-between nav-wizard nav-wizard-success">
                      <li className="nav-item">
                        <a
                          className="nav-link active fw-semibold"
                          href="#bootstrap-wizard-tab1"
                          data-bs-toggle="tab"
                          data-wizard-step="1"
                        >
                          <div className="text-center d-inline-block">
                            <span className="nav-item-circle-parent">
                              <span className="nav-item-circle">
                                <span className="fas fa-user"></span>
                              </span>
                            </span>
                            <span className="d-none d-md-block mt-1 fs-9">
                              Cliente
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link fw-semibold"
                          href="#bootstrap-wizard-tab2"
                          data-bs-toggle="tab"
                          data-wizard-step="2"
                        >
                          <div className="text-center d-inline-block">
                            <span className="nav-item-circle-parent">
                              <span className="nav-item-circle">
                                <span className="fas fa-id-badge"></span>
                              </span>
                            </span>
                            <span className="d-none d-md-block mt-1 fs-9">
                              Contactos
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link fw-semibold"
                          href="#bootstrap-wizard-tab3"
                          data-bs-toggle="tab"
                          data-wizard-step="3"
                        >
                          <div className="text-center d-inline-block">
                            <span className="nav-item-circle-parent">
                              <span className="nav-item-circle">
                                <span className="fas fa-mail-bulk"></span>
                              </span>
                            </span>
                            <span className="d-none d-md-block mt-1 fs-9">
                              Correos
                            </span>
                          </div>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link fw-semibold"
                          href="#bootstrap-wizard-tab4"
                          data-bs-toggle="tab"
                          data-wizard-step="4"
                        >
                          <div className="text-center d-inline-block">
                            <span className="nav-item-circle-parent">
                              <span className="nav-item-circle">
                                <span className="fas fa-check"></span>
                              </span>
                            </span>
                            <span className="d-none d-md-block mt-1 fs-9">
                              Hecho
                            </span>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="card-body pt-4 pb-0">
                    <div className="tab-content">
                      <div
                        className="tab-pane active"
                        role="tabpanel"
                        aria-labelledby="bootstrap-wizard-tab1"
                        id="bootstrap-wizard-tab1"
                      >
                        <div className="row g-3 mb-3">
                          <div className="col-sm-3">
                            <div className="mb-2 mb-sm-0">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-password"
                              >
                                Tipo de persona
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={tPersona}
                                value={
                                  tPersona.find(
                                    (option) =>
                                      option.value === form1.watch("idTPersona")
                                  ) || null
                                }
                                {...form1.register("idTPersona", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("idTPersona", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Tipo de entidad
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={tIdentidad}
                                value={
                                  tIdentidad.find(
                                    (option) =>
                                      option.value ===
                                      form1.watch("idTDIdentidad")
                                  ) || null
                                }
                                {...form1.register("idTDIdentidad", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("idTDIdentidad", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Número (RUC,DNI,Etc)
                              </label>
                              <input
                                className="form-control rounded-4"
                                type="number"
                                {...form1.register("nroDoc", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                              />
                              {form1.formState.errors?.nroDoc && (
                                <div className="mb-3">
                                  <code>
                                    {form1.formState.errors.nroDoc.message}
                                  </code>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-2 mt-4">
                              <button
                                className="btn btn-outline-primary rounded-pill me-1 mb-1"
                                type="button"
                                onClick={() => {
                                  apiSunat();
                                }}
                              >
                                Consultar
                              </button>
                            </div>
                          </div>
                          <div className="col-sm-5">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Rz. Social o nombre completo
                              </label>
                              <input
                                className="form-control rounded-4"
                                type="text"
                                {...form1.register("razon", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                              />
                              {form1.formState.errors?.razon && (
                                <div className="mb-3">
                                  <code>
                                    {form1.formState.errors.razon.message}
                                  </code>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-5">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Dirección fiscal
                              </label>
                              <input
                                className="form-control rounded-4"
                                type="text"
                                {...form1.register("direccion")}
                              />
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Móvil (opcional)
                              </label>
                              <input
                                className="form-control rounded-4"
                                type="number"
                                {...form1.register("celular")}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                rubro
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={rubroContribuyente}
                                value={
                                  rubroContribuyente.find(
                                    (option) =>
                                      option.value === form1.watch("idRubro")
                                  ) || null
                                }
                                {...form1.register("idRubro", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("idRubro", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Tipo
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={tipo}
                                value={
                                  tipo.find(
                                    (option) =>
                                      option.value === form1.watch("tipo")
                                  ) || null
                                }
                                {...form1.register("tipo", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("tipo", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Tipo de pago (Opcional)
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={tpago}
                                value={
                                  tpago.find(
                                    (option) =>
                                      option.value === form1.watch("tpago")
                                  ) || null
                                }
                                {...form1.register("tpago", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("tpago", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Moneda (Opcional)
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={moneda}
                                value={
                                  moneda.find(
                                    (option) =>
                                      option.value === form1.watch("idMoneda")
                                  ) || null
                                }
                                {...form1.register("idMoneda", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("idMoneda", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Observación (Opcional)
                              </label>
                              <input
                                className="form-control rounded-4"
                                type="text"
                                {...form1.register("obs")}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3 mt-7">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                id="fragileCheck"
                                type="checkbox"
                                {...form1.register("kardex")}
                              />
                              <label
                                className="form-check-label text-body fs-9"
                                htmlFor="fragileCheck"
                              >
                                Kardex
                              </label>
                            </div>
                          </div>
                          <p className="mb-0 text-body-tertiary">
                            Datos complementarios
                          </p>
                          <hr />
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Telefono 1
                              </label>
                              <input
                                className="form-control rounded-4"
                                type="text"
                                {...form1.register("telefono1")}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Telefono 2
                              </label>
                              <input
                                className="form-control rounded-4"
                                type="text"
                                {...form1.register("telefono2")}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Email
                              </label>
                              <input
                                type="email"
                                className="form-control rounded-4"
                                {...form1.register("email", {
                                  required:
                                    "El correo electrónico es obligatorio",
                                  pattern: {
                                    value:
                                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                    message: "Correo electrónico no válido",
                                  },
                                })}
                              />
                              {form1.formState.errors?.email && (
                                <div className="mb-0">
                                  <code>
                                    {form1.formState.errors.email.message}
                                  </code>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                País
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={pais}
                                value={
                                  pais.find(
                                    (option) =>
                                      option.value === form1.watch("idPais")
                                  ) || null
                                }
                                {...form1.register("idPais", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("idPais", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Region
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={region}
                                value={
                                  region.find(
                                    (option) =>
                                      option.value === form1.watch("idRegion")
                                  ) || null
                                }
                                {...form1.register("idRegion", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("idRegion", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Distrito
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={distrito}
                                value={
                                  distrito.find(
                                    (option) =>
                                      option.value === form1.watch("idDistrito")
                                  ) || null
                                }
                                {...form1.register("idDistrito", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("idDistrito", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="mb-2">
                              <label
                                className="form-label text-body"
                                htmlFor="bootstrap-wizard-wizard-confirm-password"
                              >
                                Provincia
                              </label>
                              <Select
                                className="mb-1 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                placeholder="Selecciona un tipo"
                                styles={customStyles}
                                options={provincia}
                                value={
                                  provincia.find(
                                    (option) =>
                                      option.value ===
                                      form1.watch("idProvincia")
                                  ) || null
                                }
                                {...form1.register("idProvincia", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  form1.setValue("idProvincia", event.value, {
                                    shouldValidate: true,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane"
                        role="tabpanel"
                        aria-labelledby="bootstrap-wizard-tab2"
                        id="bootstrap-wizard-tab2"
                      >
                        <div
                          className="card shadow-none border mb-3"
                          data-component-card="data-component-card"
                        >
                          <div className="card-header p-4 border-bottom bg-body">
                            <div className="row g-3 justify-content-between align-items-center">
                              <div className="col-12 col-md">
                                <h4
                                  className="text-body mb-0"
                                  data-anchor="data-anchor"
                                  id="example"
                                >
                                  Contactos
                                </h4>
                              </div>
                              <div className="col col-md-auto">
                                <nav
                                  className="nav justify-content-end doc-tab-nav align-items-center"
                                  role="tablist"
                                >
                                  <a
                                    className="btn btn-subtle-success me-1 mb-1 rounded-4"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalAgregarContacto"
                                  >
                                    Agregar
                                  </a>
                                </nav>
                              </div>
                            </div>
                          </div>
                          <div className="card-body p-0">
                            <div id="tableExample">
                              <div className="table-responsive">
                                <Table
                                  data={contacto}
                                  columns={columnsContacto}
                                  filtering={filtering}
                                  setFiltering={setFiltering}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane"
                        role="tabpanel"
                        aria-labelledby="bootstrap-wizard-tab3"
                        id="bootstrap-wizard-tab3"
                      >
                        <div
                          className="card shadow-none border mb-3"
                          data-component-card="data-component-card"
                        >
                          <div className="card-header p-4 border-bottom bg-body">
                            <div className="row g-3 justify-content-between align-items-center">
                              <div className="col-12 col-md">
                                <h4
                                  className="text-body mb-0"
                                  data-anchor="data-anchor"
                                  id="example"
                                >
                                  Correos
                                </h4>
                              </div>
                              <div className="col col-md-auto">
                                <nav
                                  className="nav justify-content-end doc-tab-nav align-items-center"
                                  role="tablist"
                                >
                                  <a
                                    className="btn btn-subtle-success me-1 mb-1 rounded-4"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalAgregarCorreo"
                                  >
                                    Agregar
                                  </a>
                                </nav>
                              </div>
                            </div>
                          </div>
                          <div className="card-body p-0">
                            <div id="tableExample">
                              <div className="table-responsive">
                                <Table
                                  data={correo}
                                  columns={columnsCorreo}
                                  filtering={filtering}
                                  setFiltering={setFiltering}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane"
                        role="tabpanel"
                        aria-labelledby="bootstrap-wizard-tab4"
                        id="bootstrap-wizard-tab4"
                      >
                        <div className="row flex-center pb-8 pt-4 gx-3 gy-4">
                          <div className="col-12 col-sm-auto">
                            <div className="text-center text-sm-start">
                              <img
                                className="d-dark-none"
                                src={imgLight}
                                alt=""
                                width="220"
                              />
                              <img
                                className="d-light-none"
                                src={imgDark}
                                alt=""
                                width="220"
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-auto">
                            <div className="text-center text-sm-start">
                              <h5 className="mb-3">
                                ¡Registra tu nuevo cliente!
                              </h5>
                              <p className="text-body-emphasis fs-9">
                                Recuerda completar los todos datos
                                correspondientes
                                <br />
                                para administrar mejor a tu cliente.
                              </p>
                              <form onSubmit={sendCliente}>
                                <button
                                  className="btn btn-primary px-6 rounded-4"
                                  type="submit"
                                >
                                  Registrar
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalAgregarContacto"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-primary">
              <h5
                className="modal-title text-white dark__text-gray-1100"
                id="staticBackdropLabel"
              >
                Datos de contacto
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={addContacto}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-4 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Nro. documento
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="number"
                      {...form2.register("nroDoc", {
                        required: {
                          value: true,
                          message: "Este campo es obligatorio",
                        },
                      })}
                    />
                    {form2.formState.errors?.nroDoc && (
                      <code>{form2.formState.errors.nroDoc.message}</code>
                    )}
                  </div>
                  <div className="col-8 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Nombre Completo
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="text"
                      {...form2.register("apeNombres")}
                    />
                  </div>
                  <div className="col-6 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Cargo
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="text"
                      {...form2.register("cargo")}
                    />
                  </div>
                  <div className="col-6 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Telefono
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="text"
                      {...form2.register("telefono")}
                    />
                  </div>
                  <div className="col-6 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Movil
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="text"
                      {...form2.register("movil")}
                    />
                  </div>
                  <div className="col-6 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Email
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="email"
                      {...form2.register("email", {})}
                    />
                  </div>
                  <div className="col-6 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Lic. Conducir
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="text"
                      {...form2.register("licConducir")}
                    />
                  </div>
                  <div className="col-6 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Observación
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="text"
                      {...form2.register("obs")}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Añadir
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalAgregarCorreo"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-primary">
              <h5
                className="modal-title text-white dark__text-gray-1100"
                id="staticBackdropLabel"
              >
                Datos de contacto
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={addCorreo}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Nombre completo
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="text"
                      {...form3.register("nombre")}
                    />
                  </div>
                  <div className="col-12 mb-2">
                    <label
                      className="form-label"
                      htmlFor="exampleFormControlInput"
                    >
                      Correo
                    </label>
                    <input
                      className="form-control rounded-4"
                      id="exampleFormControlInput"
                      type="email"
                      {...form3.register("correo")}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Añadir
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default NuevoCliente;
